module.exports = __webpack_public_path__ + "static/img/wheel-pan.2ca24c19.png";